export enum MembershipTier {
  BASIC = 'BASIC',
  EXPERT = 'EXPERT',
  PROFESSIONAL = 'PROFESSIONAL',
}
